import {
  StandardDialog,
  StandardDialogFooter,
} from "../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import React, { useState } from "react";
import Message from "../../../../pages/components/message";
import { MessageSections } from "../../../../pages/components/message/message";
import {
  InWarehouseActionTypes,
  ReadyForShipmentActionTypes,
} from "../../action-types.enum";
import ActionDialogOrderList from "../order-list/action-dialog-order-list";
import { OrderModel } from "../../../../pages/shared/models/order/order-item.model";
import ordersService from "../../../../services/orders.service";
import EmptyScanPopup from "./shared/empty";
import BarekamText from "../../../../pages/components/text";
import {
  getOrders,
  getOrdersStatesSummary,
} from "../../../../redux/slices/orders-slice";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { setIsLoading } from "../../../../redux/slices/crm.slice";
import { LocationModel } from "../../../../pages/shared/models/location.model";
import LocationSelect from "./shared/location-select";
import { TrackNumberInput } from "./track-number-input";
import { ActionDialogContent } from "./shared/styled";
import { standardDialogColumns } from "./shared/columns";

const BulkLocate = ({
  actionType,
  preSelectedOrders,
  orderStateId,
  onCancel,
  isAdditionalPopupOpen,
  setIsAdditionalPopupOpen,
  ordersUpdated,
}: BulkLocateDialogProps) => {
  const [orders, setOrders] = useState(
    preSelectedOrders || ([] as OrderModel[]),
  );
  const { ordersData } = useAppSelector((state) => state.ordersReducer);
  const { languageId } = useAppSelector((state) => state.messagesReducer);

  const dispatch = useAppDispatch();

  function searchForOrder(trackingNumberToSearch: string) {
    if (
      !!trackingNumberToSearch.length &&
      !orders.some((order) =>
        order.products.some(
          (product) => product.trackingNumber === trackingNumberToSearch,
        ),
      )
    ) {
      const filter = {
        textQuery: trackingNumberToSearch,
        state: orderStateId,
      };

      if (filter) {
        ordersService
          .getOrderByGivenFilterCriteria(filter)
          .then((order) => {
            if (order) {
              const newOrders = [...orders, order];
              updateOrders(newOrders);
            }
          })
          .catch((reason) => {
            console.log(reason);
          });
      }
    }
  }

  function updateOrders(orders: OrderModel[]) {
    setOrders(orders);
    ordersUpdated(orders);
  }

  function doAction() {
    setIsAdditionalPopupOpen && setIsAdditionalPopupOpen(true);
  }

  function onLocationSelect(selectedLocation: LocationModel) {
    if (selectedLocation) {
      dispatch(setIsLoading(true));

      const orderIds = orders.map((order) => order.orderId) as number[];

      ordersService
        .bulkUpdate(orderIds, selectedLocation, languageId)
        .then((response) => {
          if (
            actionType !==
            InWarehouseActionTypes.PRE_SELECT_LOCATION_AND_ADD_ORDERS
          ) {
            dispatch(getOrders({ page: ordersData.currentPage || 0 }));
            dispatch(getOrdersStatesSummary());
          }

          setIsAdditionalPopupOpen && setIsAdditionalPopupOpen(false);

          dispatch(setIsLoading(false));
          onCancel();
        })
        .catch((reason) => {
          console.log(reason);
          dispatch(setIsLoading(false));
        });
    }
  }

  const AdditionalDialog = () => {
    return (
      <StandardDialog
        headerLabel={
          <BarekamText variant={"l"} bold>
            <Message
              messageKey={"location"}
              sectionId={MessageSections.ORDERS}
            />
          </BarekamText>
        }
        width={"sm"}
        open={!!isAdditionalPopupOpen}
      >
        <LocationSelect
          onSave={onLocationSelect}
          onCancel={() => {
            setIsAdditionalPopupOpen && setIsAdditionalPopupOpen(false);
          }}
        />
      </StandardDialog>
    );
  };

  return (
    <>
      <ActionDialogContent>
        <TrackNumberInput onEnter={searchForOrder} />

        {orders.length ? (
          <ActionDialogOrderList
            orders={orders}
            columns={standardDialogColumns}
            updateOrders={updateOrders}
          />
        ) : (
          <EmptyScanPopup />
        )}
      </ActionDialogContent>

      <StandardDialogFooter
        saveLabel={
          orders.length ? (
            <Message messageKey={"locate"} sectionId={MessageSections.ORDERS} />
          ) : undefined
        }
        exportableOrders={orders}
        onSave={() => doAction()}
        onCancel={() => onCancel()}
      />

      <AdditionalDialog />
    </>
  );
};

interface BulkLocateDialogProps {
  actionType: InWarehouseActionTypes | ReadyForShipmentActionTypes;
  onCancel: () => void;
  orderStateId?: number | string;
  preSelectedOrders?: OrderModel[];
  isAdditionalPopupOpen?: boolean;
  setIsAdditionalPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  ordersUpdated: (orders: OrderModel[]) => void;
}

export default BulkLocate;
